import React from 'react';
import { SiWhatsapp } from "react-icons/si";

const WhatsAppButton = () => {
    return (
        <a
            href="https://wa.me/+919810252031"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
            className="fixed bottom-5 z-[9999] right-5 bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-green-300"
        >
            <SiWhatsapp
        className="text-4xl z-[9999]"
        aria-hidden="true" // hides the icon from screen readers since aria-label covers it
      />
        </a>
    );
};

export default WhatsAppButton;
